import Immutable, { Record as immutableRecord } from 'immutable';
import guid from '../../../../../libraries/utils/guid';
import config from 'config/config';
import { FRAME } from './types';
import { INSTAGRAM, TWEET } from './frame-entity-types';

var FrameEntityFields = immutableRecord({
  id: null,
  type: FRAME,
  frameType: null,
  url: null,
  startIndex: -1
});

class FrameEntity extends FrameEntityFields {
  constructor(fields = {}) {
    super(Object.assign({ id: guid() }, fields));
  }
  parse(data) {
    if (!data) {
      return this;
    }

    var fields = {};

    ['id', 'frameType', 'url', 'startIndex'].forEach(
      field => (fields[field] = data[field] !== undefined ? data[field] : this.get(field))
    );

    var newFrameEntity = new FrameEntity(fields);
    return Immutable.is(this, newFrameEntity) ? this : newFrameEntity;
  }
  getFrameSrc() {
    var url = encodeURIComponent(this.url);
    switch (this.frameType) {
      case INSTAGRAM:
        url = `${config.instagramFrame}?url=${url}`;
        break;
      case TWEET:
        url = `${config.twitterFrame}?url=${url}`;
        break;
    }
    return url;
  }
}

export default FrameEntity;
